module.exports = __webpack_public_path__ + "static/13-2e42b321a9990ac58a48fdc470030643.jpg";